import { without } from 'lodash';

import {
    CHANGE_ITEM_CRYPTA_GROUP_FAMILY,
    CLOSE_CRYPTA_GROUP_FAMILY_EDITOR,
    CryptaGroupFamilyEditorAction,
    OPEN_CRYPTA_GROUP_FAMILY_EDITOR
} from '../../actions/targetings/cryptaGroupFamily';
import { CryptaGroupFamilyEditorState } from '../../typings/audienceTargetings';
import { CryptaGroupFamilyEditorsState, State } from '../../typings/state';

export const defaultCryptaGroupFamilyEditorsState: CryptaGroupFamilyEditorState = {
    isOpen: false,
    checkedItems: []
};

export const cryptaGroupFamilyEditorsInitialState: CryptaGroupFamilyEditorsState = {};

export function cryptaGroupFamilyEditor(
    state: CryptaGroupFamilyEditorsState = cryptaGroupFamilyEditorsInitialState,
    action: CryptaGroupFamilyEditorAction,
    fullState: State
): CryptaGroupFamilyEditorsState {
    switch (action.type) {
        case OPEN_CRYPTA_GROUP_FAMILY_EDITOR: {
            const editor = state[action.id] || {
                ...defaultCryptaGroupFamilyEditorsState
            };

            if (action.itemsId.length !== 0) {
                editor.checkedItems = action.itemsId;
            }

            return {
                ...state,
                [action.id]: {
                    ...editor,
                    isOpen: true
                }
            };
        }

        case CHANGE_ITEM_CRYPTA_GROUP_FAMILY: {
            const editor = state[action.id];
            const checkedItems = editor.checkedItems;
            const itemId = action.itemId;

            return {
                ...state,
                [action.id]: {
                    ...editor,
                    checkedItems: checkedItems.includes(itemId)
                        ? without(checkedItems, itemId)
                        : checkedItems.concat(itemId)
                }
            };
        }

        case CLOSE_CRYPTA_GROUP_FAMILY_EDITOR: {
            const editor = state[action.id];

            return {
                ...state,
                [action.id]: {
                    ...editor,
                    checkedItems: action.itemsId || editor.checkedItems,
                    isOpen: false
                }
            };
        }

        default:
            return state;
    }
}
